var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{attrs:{"src":_vm.$options.methods.starSvgFile(_vm.props.rating, _vm.props.type),"width":"90","height":"18","decoding":"async","alt":"stars"}})}
var staticRenderFns = []

export { render, staticRenderFns }